"use client";
import { createContext, useContext, useState } from "react";

interface Props {
  services: any[];
  districts: any[];
  serviceQuery: string;
  districtQuery: string;
  districtInputIsFocused: boolean;
  serviceInputIsFocused: boolean;
  setDistrictInputIsFocused: (value: boolean) => void;
  setServiceInputIsFocused: (value: boolean) => void;
  setServiceQuery: (query: string) => void;
  setDistrictQuery: (query: string) => void;
}

export const GetQuoteSelectContext = createContext<Props>({
  services: [],
  districts: [],
  serviceQuery: "",
  districtQuery: "",
  districtInputIsFocused: false,
  serviceInputIsFocused: false,
  setDistrictInputIsFocused: (value) => {},
  setServiceInputIsFocused: (value) => {},
  setServiceQuery: (value) => {},
  setDistrictQuery: (value) => {},
});

export const GetQuoteSelectScreenProvider = (
  props: Props & { children: any },
) => {
  return (
    <GetQuoteSelectContext.Provider value={props}>
      {props.children}
    </GetQuoteSelectContext.Provider>
  );
};

export const useGetQuoteSelectContext = () => {
  return useContext(GetQuoteSelectContext);
};
